import axios from "@/services/axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import { isEmpty, isUndefined } from "lodash";
const ls = new SecureLS({
    isCompression: false
});

export default {
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],

    namespaced: true,

    state: {
        lojas: Array,
        pessoa: Object,
        tokenEmpresa: String,
        sessionIdNetCred: String,
        fezAcordoPorPortal: Boolean,
        botaoConsultarParcelamentosClicado: Boolean,
        temSegundaViaSenff: Boolean,
        arraySegundaViaSenff: [],
        permiteNegociar: String,
        enumCanalOrigem: '',
        codAssessoriaSenff: '',
        linkSeguroSenff: "",
        valorMinimoEntradaMulticredito: 0,
        tipoToken: String,
        meioPagamentoPadraoCobransaas: String,
    },

    mutations: {
        SET_LOJAS(estado, lojas) {
            estado.lojas = lojas;
        },
        SET_PESSOA(estado, pessoa) {
            estado.pessoa = pessoa;
        },
        SET_TOKEN_EMPRESA(estado, tokenEmpresa) {
            estado.tokenEmpresa = tokenEmpresa;
        },
        SET_SESSION_ID_NET_NETCRED(estado, sessionIdNetCred) {
            estado.sessionIdNetCred = sessionIdNetCred;
        },
        SET_FEZ_ACORDO_POR_PORTAL(estado, fezAcordoPorPortal) {
            estado.fezAcordoPorPortal = fezAcordoPorPortal;
        },
        SET_BOTAO_CONSULTAR_PARCELAMENTOS_CLICADO(estado, botaoConsultarParcelamentosClicado) {
            estado.botaoConsultarParcelamentosClicado = botaoConsultarParcelamentosClicado;
        },
        SET_TEM_SEGUNDA_VIA_SENFF(estado, temSegundaViaSenff) {
            estado.temSegundaViaSenff = temSegundaViaSenff;
        },
        ADD_ARRAY_SEGUNDA_VIA_SENFF(estado, dadosLink) {
            estado.arraySegundaViaSenff.push(dadosLink);
        },
        SET_ARRAY_SEGUNDA_VIA_SENFF(estado, arraySegundaViaSenff) {
            estado.arraySegundaViaSenff = arraySegundaViaSenff;
        },
        SET_PERMITE_NEGOCIAR(estado, permiteNegociar) {
            estado.permiteNegociar = permiteNegociar;
        },
        SET_ENUM_CANAL_ORIGEM(estado, enumCanalOrigem) {
            estado.enumCanalOrigem = enumCanalOrigem;
        },
        SET_COD_ASSESSORIA_SENFF(estado, codAssessoriaSenff) {
            estado.codAssessoriaSenff = codAssessoriaSenff;
        },
        SET_LINK_SEGURO_SENFF(estado, linkSeguroSenff) {
            estado.linkSeguroSenff = linkSeguroSenff;
        },
        SET_VALOR_MINIMO_ENTRADA_MULTICREDITO(estado, valorMinimoEntradaMulticredito) {
            estado.valorMinimoEntradaMulticredito = valorMinimoEntradaMulticredito;
        },
        SET_TIPO_TOKEN(estado, tipoToken) {
            estado.tipoToken = tipoToken;
        },
        SET_MEIO_PAGAMENTO_PADRAO_COBRANSAAS(estado, meioPagamentoPadraoCobransaas) {
            estado.meioPagamentoPadraoCobransaas = meioPagamentoPadraoCobransaas;
        },
    },

    getters: {
        getPesCpf(estado) {
            return estado.pessoa.pesCpfCnpj;
        },

        getFezAcordoPorPortal(estado) {
            return estado.fezAcordoPorPortal;
        },

        getTemSegundaViaSenff(estado) {
            return estado.temSegundaViaSenff;
        },

        getArraySegundaViaSenff(estado) {
            return estado.arraySegundaViaSenff;
        },

        getPermiteNegociar(estado) {
            return estado.permiteNegociar;
        },

        getSenffUrlSeguro(estado) {
            return estado.senffUrlSeguro;
        },

        getValorMinimoEntradaMulticredito(estado) {
            return estado.valorMinimoEntradaMulticredito;
        },

        getMeioPagamentoPadraoCobransaas(estado) {
            return estado.meioPagamentoPadraoCobransaas;
        },
    },

    actions: {
        async acaoPasso1ConsultarCpf(contexto, dados) {
            const integra_senff = contexto.rootState.parceiroConfig.identificador == 'negociasenff' ? 'S' : 'N';
            let data = {
                pes_cpf_cnpj: dados.pesCpfCnpj,
                origem_requisicao: 'S',
                integra_senff,
                identificador: contexto.rootState.parceiroConfig.identificador,
            };

            // caso o componente tenha passado o token do reCAPTCHA
            if (dados.recaptchaToken) {
                // nome usado no backend é recaptcha_token
                data.recaptcha_token = dados.recaptchaToken;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.state.enumCanalOrigem != '' &&
                contexto.state.codAssessoriaSenff != ''
            ) {
                data.enumCanalOrigem = contexto.state.enumCanalOrigem;
                data.codAssessoriaSenff = contexto.state.codAssessoriaSenff;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.rootState.linkAgentSenff != "" &&
                contexto.rootState.linkAgentSenff != null &&
                contexto.rootState.linkAgentSenff != undefined &&
                contexto.rootState.linkAgentSenff !== false
            ) {
                data.link_agent = contexto.rootState.linkAgentSenff;
            }

            const configuracaoRequisicaoAxios = {
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "passo_1",
                },

                data,
            };

            if (contexto.state.tipoToken == "J")
                configuracaoRequisicaoAxios.headers = {
                    "X-Authorization": `Bearer ${contexto.state.tokenEmpresa}`,
                    "X-Requested-With": "XMLHttpRequest",
                };
            else if (contexto.state.tipoToken == "P")
                configuracaoRequisicaoAxios.params.token = contexto.state.tokenEmpresa;

            return await axios(configuracaoRequisicaoAxios).then(resposta => {
                contexto.commit('SET_PESSOA', {});
                contexto.rootState.messageModal = {
                    show: false,
                    title: "",
                    message: "",
                    styleMessage: "danger",
                };

                let dados;
                if (resposta.data.dados) {
                    dados = resposta.data.dados;

                } else {
                    return resposta;
                }

                if (dados.meio_pagamento_padrao_cobransaas != "") {
                    contexto.commit("SET_MEIO_PAGAMENTO_PADRAO_COBRANSAAS", dados.meio_pagamento_padrao_cobransaas);
                }

                contexto.commit("SET_PESSOA", {
                    pesCodigo: dados.pes_codigo,
                    pesNome: dados.pes_nome,
                    pesCpfCnpj: dados.pes_cpf_cnpj,
                    pesEmail: dados.pes_email,
                    pefFone: dados.pef_fone
                });

                contexto.commit('SET_PERMITE_NEGOCIAR', dados.lojas[0].permite_negociar);
                contexto.commit('SET_LINK_SEGURO_SENFF', dados.senff_url_seguro);

                let lojas = dados.lojas;
                if (
                    contexto.rootState.parceiroConfig.loj_codigo_nao_negocia != null &&
                    contexto.rootState.parceiroConfig.loj_codigo_nao_negocia != undefined
                ) {
                    if (contexto.rootState.parceiroConfig.loj_codigo_nao_negocia.includes(',')) {
                        const lojasConfig = contexto.rootState.parceiroConfig.loj_codigo_nao_negocia.split(',');
                        lojas.forEach((loja, posicao) => {
                            if (lojasConfig.includes((String)(loja.loj_codigo))) {
                                lojas.splice(posicao, 1);
                            }
                        });
                    } else {
                        lojas = dados.lojas.filter(loja => loja.loj_codigo != contexto.rootState.parceiroConfig.loj_codigo_nao_negocia);
                    }
                }

                if (contexto.rootState.parceiroConfig.loj_codigo != null && contexto.rootState.parceiroConfig.loj_codigo != undefined) {
                    if (contexto.rootState.parceiroConfig.loj_codigo.includes(',')) {
                        lojas = dados.lojas.filter(loja => contexto.rootState.parceiroConfig.loj_codigo.includes(loja.loj_codigo));
                    } else {
                        lojas = dados.lojas.filter(loja => loja.loj_codigo == contexto.rootState.parceiroConfig.loj_codigo);
                    }
                }
                contexto.commit("SET_LOJAS", lojas);

                return resposta;
            });
        },

        async acaoPasso2ConsultarDividas(contexto, dados) {
            const data = {
                pes_codigo: contexto.state.pessoa.pesCodigo,
                loj_codigo: dados.lojCodigo,
                lancamento_futuro: dados.lancamentoFuturo,
                origem_requisicao: 'S',
                identificador: contexto.rootState.parceiroConfig.identificador,
            };

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.state.enumCanalOrigem != '' &&
                contexto.state.codAssessoriaSenff != ''
            ) {
                data.enumCanalOrigem = contexto.state.enumCanalOrigem;
                data.codAssessoriaSenff = contexto.state.codAssessoriaSenff;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.rootState.linkAgentSenff != "" &&
                contexto.rootState.linkAgentSenff != null &&
                contexto.rootState.linkAgentSenff != undefined &&
                contexto.rootState.linkAgentSenff !== false
            ) {
                data.link_agent = contexto.rootState.linkAgentSenff;
            }

            const configuracaoRequisicaoAxios = {
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "passo_2_novo",
                },

                data
            };

            let loja = contexto.state.lojas.filter((loja) => loja.loj_codigo == dados.lojCodigo)[0];

            if (!isUndefined(loja.hash_emp) && !isEmpty(loja.hash_emp)) {
                configuracaoRequisicaoAxios.data.hash_emp = loja.hash_emp;
                configuracaoRequisicaoAxios.data.pes_codigo = loja.pes_codigo;
            }

            if (contexto.state.tipoToken == "J") {
                configuracaoRequisicaoAxios.headers = {
                    "X-Authorization": `Bearer ${contexto.state.tokenEmpresa}`,
                    "X-Requested-With": "XMLHttpRequest"
                };
            } else if (contexto.state.tipoToken == "P") {
                configuracaoRequisicaoAxios.params.token = contexto.state.tokenEmpresa;
            }

            return await axios(configuracaoRequisicaoAxios).then(resposta => {
                if (resposta.data.dados.valor_minimo_entrada != undefined) {
                    contexto.state.valorMinimoEntradaMulticredito = resposta.data.dados.valor_minimo_entrada;
                } else {
                    contexto.state.valorMinimoEntradaMulticredito = null;
                }

                return resposta.data;
            });
        },

        async acaoPasso2ConsultarDividasStage(contexto, dados) {
            return await axios({
                method: "POST",

                url: "https://stage2.aquicob.com.br/api/cobransaas/v2/calcular",

                params: {
                    token: contexto.state.tokenEmpresa
                },

                data: {
                    pes_codigo: contexto.state.pessoa.pesCodigo,
                    loj_codigo: dados.lojCodigo,
                    fator_desconto: 0,
                    parcelamentos: null,
                    calcularDescontoParcelamento: true,
                    emp_codigo: contexto.rootState.parceiroConfig.emp_codigo,
                    meio_pagamento_padrao: contexto.getters.getMeioPagamentoPadraoCobransaas,
                }
            }).then(resposta => {
                return resposta.data;
            });
        },

        async acaoPasso3ConsultarNegociacoes(contexto, dados) {
            const data = {
                pes_codigo: contexto.state.pessoa.pesCodigo,
                loj_codigo: dados.lojCodigo,
                pre_codigo: dados.preCodigo,
                primeiro_vencimento: dados.primeiroVencimento,
                pagamento_avista_prazo: dados.pagamentoAvistaPrazo,
                metodo_pagamento: dados.metodoPagamento,
                bandeira_cartao: dados.bandeiraCartao,
                forma_cartao: dados.formaCartao,
                origem_requisicao: 'S',
                identificador: contexto.rootState.parceiroConfig.identificador,
            };

            if (dados.valorEntrada !== undefined && dados.valorEntrada !== null) {
                data.valor_entrada = dados.valorEntrada;
            }

            if (dados.numeroParcelas !== undefined && dados.numeroParcelas !== null) {
                data.numero_parcelas = dados.numeroParcelas;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.state.enumCanalOrigem != '' &&
                contexto.state.codAssessoriaSenff != ''
            ) {
                data.enumCanalOrigem = contexto.state.enumCanalOrigem;
                data.codAssessoriaSenff = contexto.state.codAssessoriaSenff;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.rootState.linkAgentSenff != "" &&
                contexto.rootState.linkAgentSenff != null &&
                contexto.rootState.linkAgentSenff != undefined &&
                contexto.rootState.linkAgentSenff !== false
            ) {
                data.link_agent = contexto.rootState.linkAgentSenff;
            }

            const configuracaoRequisicaoAxios = {
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "passo_3_novo",
                },

                data
            };

            let loja = contexto.state.lojas.filter((loja) => loja.loj_codigo == dados.lojCodigo)[0];
            if (!isUndefined(loja.hash_emp) && !isEmpty(loja.hash_emp)) {
                configuracaoRequisicaoAxios.data.hash_emp = loja.hash_emp;
                configuracaoRequisicaoAxios.data.pes_codigo = loja.pes_codigo;
            }

            if (contexto.state.tipoToken == "J") {
                configuracaoRequisicaoAxios.headers = {
                    "X-Authorization": `Bearer ${contexto.state.tokenEmpresa}`,
                    "X-Requested-With": "XMLHttpRequest"
                };
            } else if (contexto.state.tipoToken == "P") {
                configuracaoRequisicaoAxios.params.token = contexto.state.tokenEmpresa;
            }

            return await axios(configuracaoRequisicaoAxios).then(resposta => {
                if (resposta.data) {
                    return resposta.data;
                }
            });
        },

        async acaoPasso3ConsultarNegociacoesStage(contexto, dados) {
            const requestData = {
                pes_codigo: contexto.state.pessoa.pesCodigo,
                loj_codigo: dados.lojCodigo,
                pre_codigo: dados.preCodigo,
                fator_desconto: 0,
                dataVencimento: dados.primeiroVencimento,
                meio_pagamento_padrao: dados.metodoPagamento,
                pagamento_avista_prazo: dados.pagamentoAvistaPrazo,
            };

            if (dados.valorEntrada !== undefined && dados.valorEntrada !== null) {
                requestData.valor_entrada = dados.valorEntrada;
            }

            if (dados.numeroParcelas !== undefined && dados.numeroParcelas !== null) {
                requestData.numero_parcelas = dados.numeroParcelas;
            }

            return await axios({
                method: "POST",

                url: 'api.php',

                params: {
                    a: 'negociacao_robo',
                    b: 'passo_3_cobransaas',
                    token: contexto.state.tokenEmpresa
                },

                data: requestData
            }).then(resposta => {
                return resposta.data;
            });
        },

        async acaoPasso4GravarAcordo(contexto, dados) {
            const data = {
                pra_codigo: dados.praCodigo,
                forma_pagamento: dados.formaDePagamento,
                sessao_id_net_cred: dados.sessaoIdNetCred,
                dados_do_cartao: dados.dadosDoCartao,
                primeiro_vencimento: dados.primeiroVencimento,
                gerar_boleto: 1,
                origem_requisicao: 'S',
                pes_codigo: dados.pes_codigo,
                identificador: contexto.rootState.parceiroConfig.identificador,
                telefone: dados.telefone,
                email: dados.email,
            };

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.state.enumCanalOrigem != '' &&
                contexto.state.codAssessoriaSenff != ''
            ) {
                data.enumCanalOrigem = contexto.state.enumCanalOrigem;
                data.codAssessoriaSenff = contexto.state.codAssessoriaSenff;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.rootState.linkAgentSenff != "" &&
                contexto.rootState.linkAgentSenff != null &&
                contexto.rootState.linkAgentSenff != undefined &&
                contexto.rootState.linkAgentSenff !== false
            ) {
                data.link_agent = contexto.rootState.linkAgentSenff;
            }

            if (dados.id_simulacao_multicredito != null) {
                data.id_simulacao_multicredito = dados.id_simulacao_multicredito;
            }

            const configuracaoRequisicaoAxios = {
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "passo_4_novo",
                },

                data
            };

            if (!isUndefined(dados.loja.hash_emp) && !isEmpty(dados.loja.hash_emp)) {
                configuracaoRequisicaoAxios.data.hash_emp = dados.loja.hash_emp;
                configuracaoRequisicaoAxios.data.pes_codigo = dados.loja.pes_codigo;
            }

            if (contexto.state.tipoToken == "J") {
                configuracaoRequisicaoAxios.headers = {
                    "X-Authorization": `Bearer ${contexto.state.tokenEmpresa}`,
                    "X-Requested-With": "XMLHttpRequest"
                };
            } else if (contexto.state.tipoToken == "P") {
                configuracaoRequisicaoAxios.params.token = contexto.state.tokenEmpresa;
            }

            return await axios(configuracaoRequisicaoAxios).then(resposta => {
                if (resposta.data) {
                    contexto.commit('SET_FEZ_ACORDO_POR_PORTAL', true);
                    return resposta.data;
                }
            });
        },

        async acaoPasso4GravarAcordoStage(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: 'negociacao_robo',
                    b: 'passo_4_cobransaas',
                    token: contexto.state.tokenEmpresa
                },

                data: {
                    pes_codigo: contexto.state.pessoa.pesCodigo,
                    loj_codigo: dados.lojCodigo,
                    primeiro_vencimento: dados.primeiroVencimento,
                    forma_pagamento: String(dados.metodoPagamento).toUpperCase(),
                    pra_codigo: dados.praCodigo
                }
            }).then(resposta => {
                return resposta.data;
            });
        },

        async acaoPasso5RetornarAcordo(contexto, dados) {
            let data = {
                pes_codigo: contexto.state.pessoa.pesCodigo,
                loj_codigo: dados.lojCodigo,
                origem_requisicao: 'S',
                identificador: contexto.rootState.parceiroConfig.identificador,
            };

            if (dados.itensPorPagina && dados.paginaAtual && dados.pagina) {
                data = {
                    ...data,
                    itens_por_pagina: dados.itensPorPagina,
                    pagina_atual: dados.paginaAtual,
                    pagina: dados.pagina
                };
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.state.enumCanalOrigem != '' &&
                contexto.state.codAssessoriaSenff != ''
            ) {
                data.enumCanalOrigem = contexto.state.enumCanalOrigem;
                data.codAssessoriaSenff = contexto.state.codAssessoriaSenff;
            }

            if (
                contexto.rootState.parceiroConfig.identificador == 'Senff' &&
                contexto.rootState.linkAgentSenff != "" &&
                contexto.rootState.linkAgentSenff != null &&
                contexto.rootState.linkAgentSenff != undefined &&
                contexto.rootState.linkAgentSenff !== false
            ) {
                data.link_agent = contexto.rootState.linkAgentSenff;
            }

            const configuracaoRequisicaoAxios = {
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "passo_5",
                },

                data
            };

            let loja = contexto.state.lojas.filter((loja) => loja.loj_codigo == dados.lojCodigo)[0];
            if (!isUndefined(loja.hash_emp) && !isEmpty(loja.hash_emp)) {
                configuracaoRequisicaoAxios.data.hash_emp = loja.hash_emp;
                configuracaoRequisicaoAxios.data.pes_codigo = loja.pes_codigo;
            }

            if (contexto.state.tipoToken == "J") {
                configuracaoRequisicaoAxios.headers = {
                    "X-Authorization": `Bearer ${contexto.state.tokenEmpresa}`,
                    "X-Requested-With": "XMLHttpRequest"
                };
            } else if (contexto.state.tipoToken == "P") {
                configuracaoRequisicaoAxios.params.token = contexto.state.tokenEmpresa;
            }

            return await axios(configuracaoRequisicaoAxios).then(resposta => {
                if (resposta.data) {
                    return resposta.data;
                }
            });
        },

        async acaoRetornarTokenEmpresa(contexto) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "portal",
                    b: "retornarTokenEmpresa"
                },

                data: {
                    emp_codigo: contexto.rootState.parceiroConfig.emp_codigo,
                    token: contexto.rootState.globalToken
                }

            }).then(resposta => {

                if (resposta.data.dados !== null) {
                    if (resposta.data.dados.token_jwt != undefined) {
                        contexto.commit("SET_TOKEN_EMPRESA", resposta.data.dados.token_jwt);
                        contexto.commit("SET_TIPO_TOKEN", "J");
                    } else {
                        contexto.commit("SET_TOKEN_EMPRESA", resposta.data.dados.token_api);
                        contexto.commit("SET_TIPO_TOKEN", "P");
                    }
                }

                return resposta;
            });
        },

        async acaoEnviarSmsEmailSegundaViaSenff(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao_robo",
                    b: "enviar_email_sms",
                    token: contexto.state.tokenEmpresa
                },

                data: {
                    pes_cpf_cnpj: dados.pesCpfCnpj,
                    texto: "",
                    linha_digitavel: dados.linhaDigitavel,
                    pix_copia_cola: dados.pixCopiaECola,
                    tipo: dados.tipoEnvio,
                    endereco_envio: dados.enderecoEnvio,
                    loj_codigo: dados.loj_codigo,
                },
            }).then(resposta => {
                return resposta;
            });
        },

        async action_click_banner_hapvida(contexto) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "portal",
                    b: "registrarClickBannerHapvida",
                    token: contexto.state.tokenEmpresa
                },
            });
        }
    }
}
